<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- SMTP认证 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.autu1") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 启用 -->
                                <td>{{ $t("logs.base8_a1") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="bysmtp">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.autu1_a1')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr>
                                <!-- SMTP服务器-->

                                <td>{{ $t("logs.autu1_a2") }}:</td>
                                <td>
                                    <el-input v-model="smtp_host" placeholder style="margin-bottom:0"></el-input>

                                    <el-alert :title="$t('logs.autu1_a3')" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                            <tr>
                                <!-- SMTP服务器端口-->

                                <td>{{ $t("logs.autu1_a4") }}:</td>
                                <td>
                                    <el-input v-model="smtp_port" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- EHLO主机名-->

                                <td>{{ $t("logs.autu1_a5") }}:</td>
                                <td>
                                    <el-input v-model="smtp_helo_host" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- SMTP认证机制-->

                                <td>{{ $t("logs.autu1_a6") }}:</td>
                                <td>
                                    <el-select v-model="smtp_mech" placeholder class="selece1">
                                        <el-option v-for="item in smtpmech" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr v-if="this.smtp_mech == 'NTLM'">

                                <td></td>
                                <td style="display:flex; flex-direction:row">
                                    <el-checkbox-group v-model="ntlm_half">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.autu1_a1')" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_smtp" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- POP3认证 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.autu2") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 启用 -->
                                <td>{{ $t("logs.base8_a1") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="bypop">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.autu2_a1')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr>
                                <!-- POP3服务器 -->

                                <td>{{ $t("logs.autu2_a2") }}:</td>
                                <td>
                                    <el-input v-model="pop_host" placeholder></el-input>
                                    <el-alert :title="$t('logs.autu1_a3')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr>
                                <!-- POP3服务器端口 -->

                                <td>{{ $t("logs.autu2_a3") }}:</td>
                                <td>
                                    <el-input v-model="pop_port" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- sll -->

                                <td>{{ $t("logs.autu2_a4") }}:</td>
                                <td>
                                    <el-checkbox-group v-model="pop_ssl">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_pop()" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- IMAP认证 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.autu3") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 启用 -->
                                <td>{{ $t("logs.base8_a1") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="byimap">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.autu3_a1')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr>
                                <!-- IMAP服务器 -->

                                <td>{{ $t("logs.autu3_a2") }}:</td>
                                <td>
                                    <el-input v-model="imap_host" placeholder></el-input>

                                    <el-alert :title="$t('logs.autu1_a3')" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                            <tr>
                                <!-- IMAP服务器端口 -->

                                <td>{{ $t("logs.autu3_a3") }}:</td>
                                <td>
                                    <el-input v-model="imap_port" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- sll -->

                                <td>{{ $t("logs.autu2_a4") }}:</td>
                                <td>
                                    <el-checkbox-group v-model="imap_ssl">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_imap()" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>
                                  
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- AD认证 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.autu4") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 启用 -->
                                <td>{{ $t("logs.base8_a1") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="byad">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.autu4_a1')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>

                            <tr>
                                <!-- LDAP服务器 -->

                                <td>{{ $t("logs.autu4_a2") }}:</td>
                                <td>
                                    <el-input v-model="ad_host" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- LDAP服务器端口 -->

                                <td>{{ $t("logs.autu4_a3") }}:</td>
                                <td>
                                    <el-input v-model="ad_port" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- LD Base -->

                                <td>{{ $t("logs.autu4_a4") }}:</td>
                                <td>
                                    <el-input v-model="ld_base" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- LDAP DN -->

                                <td>{{ $t("logs.autu4_a5") }}:</td>
                                <td>
                                    <el-input v-model="ld_dn" placeholder></el-input>
                                </td>
                            </tr>
                             <tr>
                                <!-- Query Filter-->

                                <td>Query Filter:</td>
                                <td>
                                    <el-input v-model="ld_filter" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- LDAP PASSWORD -->

                                <td>{{ $t("logs.autu4_a6") }}:</td>
                                <td>
                                    <el-input v-model="ld_pass" placeholder show-password></el-input>
                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_ad()"
                                    :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>
                                   
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- 认证测试 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.autu5") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <td></td>
                                <td>
                                    <el-alert :title="$t('logs.autu5_a1')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>

                            <tr>
                                <!-- 邮箱账号 -->

                                <td>{{ $t("logs.autu5_a2") }}:</td>
                                <td>
                                    <el-input v-model="username" placeholder clearable></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- 密码 -->

                                <td>{{ $t("logs.autu5_a3") }}:</td>
                                <td>
                                    <el-input v-model="password" placeholder show-password clearable></el-input>
                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_text()" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.autu5_a4')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- 认证控制 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.autu6") }}
                </span>
                <div class="main">

                    <ul>
                        <li>{{ $t("logs.autu6_a2") }}:</li>
                        <el-input placeholder v-model="auth_fail_time" clearable></el-input> <span style="padding-left:0;padding-right:20px">{{ $t("logs.autu6_a3") }}</span>
                        <li>{{ $t("logs.autu6_a4") }}:</li>
                        <el-input placeholder v-model="auth_fail_num" clearable></el-input>
                        <el-button @click="tanSend_save()" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>
                        <el-button @click="tan" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.autu6_a1") }}</el-button>
                    </ul>

                </div>
                <div class="switch1">
                    <div class="table table02">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"></el-table-column>
                            <el-table-column prop="IPADDR" :label="$t('logs.manage3')"></el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')" width="100">
                                <template slot-scope="scope">
                                    <!-- 删除-->
                                    <el-button @click="handleClick5(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0"> {{ $t("table1.delete") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_cert_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_cert_domain"><span class="span_pad"></span> {{$t('logs.autu6')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">{{$t('logs.manage3')}}:</div>
                                <div class="block block1">
                                    <el-input v-model="ipaddr" placeholder></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend_table_auth()" :disabled="$root.jurisdiction.only_query == 0">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanOff()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            // SMTP认证
            ntlm_half: [],
            data_loadok_smtp: '',
            data_loadok_pop: '',
            data_loadok_imap: '',
            data_loadok_ad: '',
            bysmtp: [],
            smtp_host: '',
            smtp_port: '',
            smtp_helo_host: '',
            smtp_mech: "LOGIN",
            smtpmech: [],
            // POP3
            bypop: '',
            pop_host: '',
            pop_port: '',
            pop_ssl: '',
            // IMAP
            byimap: [],
            imap_host: '',
            imap_port: '',
            imap_ssl: '',
            ld_filter:'',
            // AD
            byad: [],
            ad_host: '',
            ad_port: '',
            ld_base: '',
            ld_dn: '',
            ld_pass: '',
            // 认证测试
            password: '',
            username: '',
            // 认证控制
            auth_fail_time: '',
            auth_fail_num: '',
            ipaddr: '',

            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS"
                },
                {
                    value: "选项2",
                    label: "增加信头标记"
                },
                {
                    value: "选项3",
                    label: "强制TLS"
                }
            ],
            checked: "",
            fileList: [],
            radio: []
        };
    },
    mounted() {
        this.getFileList1()
        this.getFileList2()
        this.getFileList3()
        this.getFileList4()
        this.getFileList5()
    },
    methods: {
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
            this.ipaddr = ''
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        // 认证控制 加载
        getFileList5() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_ipauthok",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList = res.data.ret.datalist;
                        this.auth_fail_time = res.data.ret.AUTH_FAIL_TIME
                        this.auth_fail_num = res.data.ret.AUTH_FAIL_NUM
                        // 

                    }
                })
               
        },
        // 失败周期认证控制 保存
        tanSend_save() {

            this.loading = true;
            this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_auth_ctl",
                sid: sid,
                auth_fail_time: this.auth_fail_time,
                auth_fail_num: this.auth_fail_num,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList5();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del3')}`,
                        });

                    }
                })
               

        },
        // 认证控制 保存
        tanSend_table_auth() {
    this.$disable_hint_test();
    this.$save_hint_test();
         
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_ipauthok",
                sid: sid,
                ipaddr: this.ipaddr,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
            this.$close_hint_test();
            this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        
            this.tanchu = false
                        this.loading = false;
                        this.getFileList5();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del3')}`,
                        });
                        this.ipaddr = ''

                    }
                })
               

        },
        // 认证控制 删除
        handleClick5(index, scope) {
            console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    this.loading = true
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let authokip = scope.ORGIP;
                    let str = this.$qs.stringify({
                        __mode: "del_ipauthok",
                        sid: sid,
                        authokip: authokip,

                    });
                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList5();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        // 认证测试
        tanSend_text() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "test_auth",
                sid: sid,

                username: this.username,
                password: this.password,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList4();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.auth_sueecss')}`,
                        });

                    }
                })
               

        },
        // ad加载
        getFileList4() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_ad_auth",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.byad = res.data.ret.result.USE_AD_AUTH == 0 ? this.byad = false : true
                        this.imap_ssl = res.data.ret.result.USE_IMAP_AUTH_SSL == 0 ? this.imap_ssl = false : true

                        this.ad_host = res.data.ret.result.AD_SERVER_HOST

                        this.ad_port = res.data.ret.result.AD_SERVER_PORT
                        this.ld_base = res.data.ret.result.LD_BASE
                        this.ld_dn = res.data.ret.result.LDAP_DN
                        this.ld_pass = res.data.ret.result.LDAP_PASSWORD
                        this.ld_filter = res.data.ret.result.AD_FILTER_SEARCH_OPTION
                        this.data_loadok_ad = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
               
        },
        // ad保存
        tanSend_ad() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_ad_auth",
                sid: sid,
                byad: this.byad == true ? 1 : 0,

                ad_host: this.ad_host,
                ad_port: this.ad_port,
                ld_base: this.ld_base,
                ld_dn: this.ld_dn,
                ld_pass: this.ld_pass,
                ld_filter:this.ld_filter,

                data_loadok: this.data_loadok_ad

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
                this.$close_hint_test();
                this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList4();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
        // imap加载
        getFileList3() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_imap_auth",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.byimap = res.data.ret.result.USE_IMAP_AUTH_AS_GATEWAY == 0 ? this.byimap = false : true
                        this.imap_ssl = res.data.ret.result.USE_IMAP_AUTH_SSL == 0 ? this.imap_ssl = false : true

                        this.imap_host = res.data.ret.result.USE_IMAP_AUTH_AS_GATEWAY_EX_SERVER

                        this.imap_port = res.data.ret.result.AUTH_IMAP_PORT
                        this.data_loadok_imap = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
               
        },
        // imap保存
        tanSend_imap() {

          this.$save_hint_test();
          this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_imap_auth",
                sid: sid,
                imap_ssl: this.imap_ssl == true ? 1 : 0,
                byimap: this.byimap == true ? 1 : 0,
                imap_host: this.imap_host,
                imap_port: this.imap_port,

                data_loadok: this.data_loadok_imap

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList3();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
        // POP 加载
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_pop_auth",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.bypop = res.data.ret.result.USE_POP_AUTH_AS_GATEWAY == 0 ? this.bypop = false : true
                        this.pop_ssl = res.data.ret.result.USE_POP_AUTH_SSL == 0 ? this.pop_ssl = false : true

                        this.pop_host = res.data.ret.result.USE_POP_AUTH_AS_GATEWAY_EX_SERVER

                        this.pop_port = res.data.ret.result.AUTH_POP_PORT
                        this.data_loadok_pop = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
               
        },
        // pop保存
        tanSend_pop() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_pop_auth",
                sid: sid,
                pop_ssl: this.pop_ssl == true ? 1 : 0,
                bypop: this.bypop == true ? 1 : 0,
                smtp_host: this.smtp_host,
                pop_port: this.pop_port,
                pop_host: this.pop_host,

                data_loadok: this.data_loadok_pop

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList2();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
        // SMTP 加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_smtp_auth",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.bysmtp = res.data.ret.result.USE_SMTP_AUTH_AS_GATEWAY == 0 ? this.bysmtp = false : true
                        this.ntlm_half = res.data.ret.result.SMTP_AUTH_NTML_JUST_USE_HALF == 0 ? this.ntlm_half = false : true
                        this.smtpmech = res.data.ret.q_smtp_mech

                        this.smtp_host = res.data.ret.result.USE_SMTP_AUTH_AS_GATEWAY_EX_SERVER
                        this.smtp_port = res.data.ret.result.AUTH_SMTP_PORT
                        this.smtp_helo_host = res.data.ret.result.AUTH_SMTP_EHLO_HOST
                        this.smtp_host = res.data.ret.result.USE_SMTP_AUTH_AS_GATEWAY_EX_SERVER

                        this.smtp_mech = res.data.ret.result.AUTH_SMTP_MECH
                        this.data_loadok_smtp = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
               
        },
        // SMTP保存
        tanSend_smtp() {
           this.$save_hint_test();
           this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_smtp_auth",
                sid: sid,
                ntlm_half: this.ntlm_half == true ? 1 : 0,
                bysmtp: this.bysmtp == true ? 1 : 0,
                smtp_host: this.smtp_host,
                smtp_port: this.smtp_port,
                smtp_helo_host: this.smtp_helo_host,
                smtp_mech: this.smtp_mech,

                data_loadok: this.data_loadok_smtp

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
    }
};
</script>

<style lang="less" scoped>
// IP白名单
.table02 {
    /deep/ .has-gutter th:nth-child(1) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(3) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(2) {
        text-align: left;

    }

    // 表格居中位置
    /deep/ .el-table__row td:nth-child(1) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(3) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(2) {
        text-align: left;

    }

}

// tls设置表头
.table06 {
    /deep/ .has-gutter th:nth-child(1) {
        text-align: center;

    }

    // /deep/ .has-gutter th:nth-child(2) {
    //     text-align: left;

    // }

    /deep/ .has-gutter th:nth-child(3) {
        text-align: center;

    }

    // 表格居中位置
    /deep/ .el-table__row td:nth-child(1) {
        text-align: center;

    }

    // /deep/ .el-table__row td:nth-child(2) {
    //     text-align: left;

    // }

    /deep/ .el-table__row td:nth-child(3) {
        text-align: center;

    }
}

// input 框高度
/deep/ .el-input__i nner {
    height: 30px;
}

//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

// 搜索
.main {
    // padding-top: 10px;
    // padding-bottom: 10px;
    // border: 1px solid #ddd;

    // border-top: 3px solid #424f63;

    margin: 5px;

    padding-left: 10px;
    text-align: left;
    // margin-top: 5px;
    background: #fff;

    ul {
        line-height: 30px;
        width: 100%;
        display: flex;
        align-items: center;
        font-size: 12px;

        .el-input {
            width: 10%;
            margin: 0px 10px;
        }

        li {
            width: 80px;
            text-align: right;
        }
    }

}

/deep/ .el-input__inner {
    height: 24px;
    line-height: 24px;
    font-size: 12px !important;
}

.main p {
    padding-left: 10px;
    font-size: 14px;
    line-height: 28px;
}

// .main span {
//     // padding-left: 20px;
// }

// .el-button {
//     padding: 6px;
// }

// .find2 {
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     //   height: 300px;
//     padding-top: 30px;
//     padding-left: 30px;
//     width: 50%;
//     margin-bottom: 20px;
// }

// .find2-1 {
//     width: 100%;
//     padding-bottom: 10px;
//     display: flex;
//     align-items: center;
//     //   justify-content: center;

//     div {
//         padding: 0 5px;
//     }
// }

// .find2-1 .find-text {
//     font-size: 14px;
// }

// .find2-1 .el-row {
//     margin-left: 140px;
// }

// 弹出框1
// 一行
// .find {
//     display: flex;
//     //   flex: 1;
//     overflow: auto;
//     flex-direction: column;
//     text-align: left;
//     background: #f1f1f1;
//     border: 1px solid #dcdfe6;
//     margin-top: 10px;
//     padding: 40px 0;
//     width: 80%;

//     p {
//         color: #999;
//         font-size: 12px;
//         text-align: center;
//     }
// }

// .find1 {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     margin: 2px 0;
// }

// // 文字
// .find-text {
//     padding: 0 20px;
//     font-size: 12px;
// }

/deep/ .el-select {
    // padding-left: 30px;
    width: 222px;
}

// 表格下的button
.lie tr:last-child {
    /deep/ .el-button {
        margin: 5px;
    }
}

// // button  按钮
// /deep/ .el-button {
//     padding: 5px 10px;
//     margin-left: 10px;
//     font-size: 12px;
//     background: #eceff4;
// }

// .pop-up {
//     position: fixed;
//     padding: 20px 0;
//     width: 50%;
//     //   height: 80%;
//     top: 10%;
//     left: 25%;
//     z-index: 101;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     background: white;
//     //   margin-left: -12.5%;
//     //   margin-top: -14%;
// }

.gray {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: black;
    opacity: 0.6;
    z-index: 100;
}

.el-checkbox-group {
    display: flex;
}

.table span {
    font-size: 14px;
}

// th  改高度
/deep/ .el-table th {
    padding: 4px 0;
}

// td  改高度
/deep/ .el-table td {
    padding: 4px 0;
}

// 时间
.time {
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
    background: #f1f1f1;
    margin: 10px 0;
}

.time1 {
    display: flex;
    align-items: center;
    padding: 2px 0 2px 14px;
    font-size: 14px;
}

// 手动设置
.time-text1 {
    padding-left: 20px;
}

// 后台管理控制
.back {
    display: flex;
    font-size: 14px;
    line-height: 30px;
    align-items: center;
    padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
    margin: 0 10px;
}

.backText {
    text-align: right;
}

.backText1 {
    color: #999;
    font-size: 12px;
}

.back .el-input {
    width: 20%;
    padding: 0;
}

.time2 {
    display: flex;
    margin-left: 190px;
    margin-top: 10px;
}

.time2 .el-button {
    padding: 8px 24px;
    // margin: 10px ;
}

// License
.time3 {
    display: flex;
    align-items: center;
    // margin-left: 150px;
    font-size: 14px;
    padding: 4px 10px;
}

// selece
.selece1 {
    width: 280px;
}

// input 框
.back1 .input1 {
    width: 100px;
    margin: 0 10px;
}

// 单选框
.check1 {
    margin: 0 10px;
}

.backText2 {
    margin-left: 40px;
}

.backText3 {
    margin-left: 30px;
}

.back1 .input5-1 {
    width: 100px;
}

// .switch1 {
//     padding: 0 5px;
//     margin-bottom: 20px;
// }

// 三级菜单背景
// /deep/ .el-tabs__nav-scroll {
//     //   border-bottom: 1px solid #ddd;
//     font-size: 12px;
//     background: #eee;
//     // background: #eee;
// }

// /deep/ .el-tabs__nav-scroll {
//     display: flex;
//     padding-left: 0px;
//     justify-content: space-between;
// }

// 弹框下的复选框
.el-checkbox:last-of-type {
    margin-right: 10px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
</style>
